<template>
	<div class="comp">
		<el-dialog :title="''" :visible.sync="dialogState" width="1500px" top="50px">
			<div class="tabLine">
				<div class="tabItem" :class="[curTabIndex==0?'active':'']" @click="changeTab(0)">充值活动</div>
				<div class="tabItem" :class="[curTabIndex==1?'active':'']" @click="changeTab(1)">消费活动</div>
			</div>
			<div style="padding-top:10px;">
				<div v-show="curTabIndex==0" style="display: inline-flex;width:300px;">
					<div style="width:80px;line-height: 40px;padding-left: 10px;">关键字：</div>
					<el-input v-model="search.keyword" @keyup.enter.native="clickSearch"></el-input>
				</div>
				<div v-show="curTabIndex==1" style="display: inline-flex;width:300px;">
					<div style="width:80px;line-height: 40px;padding-left: 10px;">关键字：</div>
					<el-input v-model="search1.keyword" @keyup.enter.native="clickSearch"></el-input>
				</div>
				<div style="display: inline-block;margin-left: 30px;">
					<el-button type="success" @click="clickSearch" >搜索</el-button>
				</div>
			</div>
			<el-table v-show="curTabIndex==0" class="table" :data="rechargeList" style="width: 100%">
				<el-table-column prop="name" label="活动名称" width="400">
				</el-table-column>
				<el-table-column label="截止日期" width="400">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.exprice_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" >
				</el-table-column>
				<!-- <el-table-column label="操作" width="300">
					<template slot-scope="scope">
						<el-button type="primary"  size="small">查看</el-button>
					</template>
				</el-table-column> -->
			</el-table>
			<el-table v-show="curTabIndex==1" class="table" :data="saleList" style="width: 100%">
				<el-table-column prop="name" label="活动名称" width="400">
				</el-table-column>
				<el-table-column label="截止日期" width="400">
					<template slot-scope="scope">
						{{$public.FTime(scope.row.exprice_time)}}
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" >
				</el-table-column>
				<el-table-column label="操作" width="300">
					<template slot-scope="scope">
						<el-button type="primary" @click="see_saleDetail(scope.row)" size="small">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<page v-show="curTabIndex===0" :page="page.page" :total="page.total" @change="changePage"></page>
			<page v-show="curTabIndex===1" :page="page1.page" :total="page1.total" @change="changePage1"></page>
		</el-dialog>
		<div style="width:0;height: 0;display: inline-block;" v-if="dialogState_activityDetail">
			<dialogActivityDetail :row="curActivityDetail" @close="dialogState_activityDetail = false"></dialogActivityDetail>
		</div>
	</div>
</template>
<script>
	import page from "./page.vue"
	import dialogActivityDetail from "./dialog_activityDetail.vue" 
	export default {
		components:{page,dialogActivityDetail},
		data() {
			return {
				dialogState:true,
				search:{
					keyword:''
				},
				search1:{
					keyword:''
				},
				title:'',
				curTabIndex:0,
				rechargeList:[],
				saleList:[],
				page:{
					page:1,
					pageSize:10,
					total:0
				},
				page1:{
					page:1,
					pageSize:10,
					total:0
				},
				// 活动详情
				dialogState_activityDetail:false,
				curActivityDetail:{},
			}
		},
		computed:{
			curShopId(){
				return this.$store.state.shopId;
			},
		},
		watch:{
			dialogState(n){
				this.$emit('close',n)
			}
		},
		mounted() {
			this.getRechargeData();
			this.getSaleData()
		},
		methods: {
			see_saleDetail(row){
				this.curActivityDetail=row;
				this.dialogState_activityDetail = true;
			},
			// 搜索关键字
			clickSearch(){
				if(this.curTabIndex===0){
					this.page.page=1;
					this.getRechargeData()
				}else{
					this.page1.page=1;
					this.getSaleData()
				}
			},
			// 改变tab
			changeTab(index){
				this.curTabIndex=index;
			},
			// 改变分页
			changePage(a){
				this.page.page=a;
				this.getRechargeData();
			},
			changePage1(a){
				this.page1.page=a;
				this.getSaleData();
			},
			// 获取表格数据
			getRechargeData() {
				let loading = this.$loading()
				this.$http.get('/api/Activity/List', {
					type_id:1,  // 1 充值 2 消费
					keyword:this.search.keyword,
					pageIndex:this.page.page,
					pageSize:this.page.pageSize,
				}).then(res => {
					loading.close();
					if (res.code == 0) {
						this.rechargeList = res.data.data;
						this.page.total = res.data.count;
					}
				})
			},
			// 获取表格数据
			getSaleData() {
				let loading = this.$loading()
				this.$http.get('/api/Activity/List', {
					type_id:2,  // 1 充值 2 消费
					keyword:this.search.keyword,
					pageIndex:this.page1.page,
					pageSize:this.page1.pageSize,
				}).then(res => {
					loading.close();
					if (res.code == 0) {
						this.saleList = res.data.data;
						this.page1.total = res.data.count;
					}
				})
			},
		}
	}
</script>
<style lang="scss" scoped>
	.comp {
		.navLine{
			display: flex;
			font-size: 18px;
			border-bottom:1px solid #DDDDDD;
			.label{
				color:#1A1A1A;
				font-weight: bold;
				padding:10px 10px 10px 27px;
			}
			.navItem{
				color:#555555;
				margin:0 20px;
				padding:10px 0;
				cursor: pointer;
				&.active{
					border-bottom:2px solid #FDD000;
				}
			}
		}
		.labelBox{
			display: flex;
			margin:2px 0 0;
			.label{
				font-size: 16px;
				font-weight: bolder;
				flex-shrink: 0;
				line-height: 25px;
				display: inline-block;
				width:65px;
				text-align: right;
			}
			.labelItemBox{
				display: flex;
				flex-wrap: wrap;
				padding-left:10px;
				box-sizing: border-box;
				.labelItem{
					font-size: 14px;
					padding:5px 5px 3px;
					border-radius: 2px;
					margin:2px 3px;
					color:#555555;
					cursor: pointer;
					&.active{
						background-color:#FDD000;
					}
					&:hover{
						background-color:#FDD000;
					}
				}
			}
		}
		.tabLine{
			display: flex;
			margin:20px 0 10px;
			.tabItem{
				margin-right: 40px;
				padding:0 10px 5px;
				font-size: 16px;
				cursor: pointer;
				&.active{
					color:#FDD000;
					border-bottom:2px solid #FDD000;
				}
			}
		}
		::v-deep.el-dialog__body{
			padding-top:0;
		}
	}
</style>
